module.exports = __webpack_public_path__ + "img/plan-silver.d54fa4dd.svg";